import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import FolderIcon from '@mui/icons-material/Folder';
import {
  Backdrop,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Grid,
  ListItem,
  TextField,
  Box,
  Badge
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'src/utils/Common';
import AlertAndLoading from 'src/components/AlertAndLoading';
import axios from 'src/utils/axios';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CompressMaterial = require('compress.js');
const compressMaterial = new CompressMaterial();

const useStyles = makeStyles((theme) => ({
  divCenter: {
    textAlign: 'center'
  },
  backdrop: {
    zIndex: 9999,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 210,
    zIndex: 7,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    marginBottom: '16px'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  div: {
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%',
    color: 'red'
  },
  div2: {
    fontSize: '12px',
    width: '100%'
  },
  img: {
    width: '100%',
    maxWidth: '600px'
  }
}));

function FileInfo() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const SessionUser = getUser();

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );

  const [showFile, setShowFile] = React.useState(false);
  const [uploadFilePopUp, setUploadFilePopUp] = React.useState(false);
  const [openFilePopUp, setOpenFilePopUp] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [fileList, setFileList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectedFileType, setSelectedFileType] = React.useState(null);
  const [uyari, setUyari] = React.useState(false);
  const [openFileCount, setOpenFileCount] = React.useState(0);
  //MHTU-3401 Ürün Satış Faturası veya Fişi veya Sevk İrsaliyesi belge tipi
  const salesDocumentFileTypeId = 24;
  const [renk, setRenk] = React.useState('black');

  const [alertType, setAlertType] = React.useState({
    ErrorType: 'error',
    ErrorTitle: 'Uyarı'
  });
  const [responseMessage, setresponseMessage] = React.useState('');

  const fileTypeData = useSelector(
    (state) => state.generalFollowSlice.fileTypes
  );
  const receiptNumber = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  )[0]?.Apply?.ReceiptNumber;

  // fileId -> { url, loading } : onceden indirilmis dosyalarin object URL'leri
  const prefetchRef = React.useRef({});

  const revokeAllPrefetched = () => {
    Object.values(prefetchRef.current).forEach((entry) => {
      if (entry && entry.url) {
        try {
          URL.revokeObjectURL(entry.url);
        } catch (e) {}
      }
    });
    prefetchRef.current = {};
  };

  // Liste acildiginda tum dosyalari arka planda (tam cozunurluk, JWT'li) indirip
  // hazir tut; boylece kullanici tikladiginda dosya aninda acilir.
  const prefetchFiles = (files) => {
    (files || []).forEach((row) => {
      const id = row.fileId;
      if (!id || prefetchRef.current[id]) {
        return; // zaten indirildi ya da indiriliyor
      }
      prefetchRef.current[id] = { url: null, loading: true };
      axios
        .get('/GetFileContent/' + receiptNumber + '/' + id, {
          responseType: 'blob'
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: row.contentType });
          prefetchRef.current[id] = {
            url: URL.createObjectURL(blob),
            loading: false
          };
        })
        .catch(() => {
          // basarisizsa haritadan cikar ki tiklamada tekrar denensin
          delete prefetchRef.current[id];
        });
    });
  };

  useEffect(() => {
    getOpenFile();
  }, [dispatch]);

  // Fis degisince / bilesen kalkinca prefetch edilen URL'leri serbest birak
  useEffect(() => {
    return () => revokeAllPrefetched();
  }, [receiptNumber]);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const getOpenFile = () => {
    axios
      .get('/OpenFileCount/' + receiptNumber, {
        responseType: 'arrayBuffer'
      })
      .then((response) => {
        setOpenFileCount(response.data);
      });
  };

  const getReceiptFiles = () => {
    setLoading(true);
    if (!receiptNumber) {
      setLoading(false);
      return;
    }
    axios
      .get('/GetReceiptFiles/' + receiptNumber)
      .then((response) => {
        const data =
          typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data;
        const images = (data || []).map((element) => ({
          fileName:
            element.FileDesc +
            ' - ' +
            element.FileName +
            ' - ' +
            element.FileCreateUser,
          fileId: element.FileId,
          fileCreateUserId: element.FileCreateUserId,
          contentType: element.ContentType,
          FileTypeId: element.FileTypeId
        }));
        setFileList(images);
        setOpenFilePopUp(true);
        setLoading(false);
        // Dosyalari arka planda indirip hazir tut (tiklamada aninda acilsin)
        prefetchFiles(images);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  function uploadFiles(filedata) {
    setLoading(true);
    axios
      .post('/UploadFile', filedata, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        setOpenFilePopUp(false);
        getOpenFile();
        setSelectedFileType(null);
        if (filedata.TypeId == 1 || filedata.TypeId == salesDocumentFileTypeId) {
          var tempData = JSON.parse(JSON.stringify(invoiceData));
          if (filedata.TypeId == 1) {
            tempData[0].Exchange.BankFile = 1;
          }
          //MHTU-3401 Belge yüklendiğinde onay kontrolünün güncel çalışması için
          if (filedata.TypeId == salesDocumentFileTypeId) {
            tempData[0].Exchange.SalesDocumentFileExists = 1;
          }
          dispatch(generalFollowActions.updateNewData(tempData));
        }
        setLoading(false);
      })
      .catch((err) => {
        setresponseMessage({
          ErrorCode: 0,
          ErrorDescription: err.response.data
        });
        setUyari(true);
        setOpenFilePopUp(false);
        setSelectedFileType(null);
        setLoading(false);
        return;
      });
  }

  const handleDeleteSureClick = (fileId, fileCreateUserId) => {
    if (fileCreateUserId !== SessionUser.UserId.toString()) {
      InfoAlert(
        'Sadece eklediğiniz dosyaları silebilirsiniz!...',
        'error',
        'Hata'
      );
      return;
    }

    setOpenFilePopUp(false);
    confirmAlert({
      message: 'Silmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleDeleteClick(fileId)
        },
        {
          label: 'Hayır',
          onClick: () => {
            setOpenFilePopUp(true);
          }
        }
      ]
    });
  };

  const handleDeleteClick = (fileId) => {
    const Filecount = fileList.filter((obj) => obj.FileTypeId === 1).length;
    //MHTU-3401 Silme sonrasında fişte kalan ürün satış belgesi sayısı
    const remainingSalesDocumentCount = fileList.filter(
      (obj) =>
        obj.FileTypeId == salesDocumentFileTypeId && obj.fileId !== fileId
    ).length;
    setLoading(true);
    axios
      .get('/DeleteFile/' + fileId, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        setOpenFilePopUp(false);
        getOpenFile();
        setLoading(false);
      });
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.BankFile = Filecount > 1 ? 1 : 0;
    //MHTU-3401
    tempData[0].Exchange.SalesDocumentFileExists =
      remainingSalesDocumentCount > 0 ? 1 : 0;
    dispatch(generalFollowActions.updateNewData(tempData));
  };

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    });
    setUyari(true);
    return;
  }

  async function base64Reader(file) {
    const result_base64 = await new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = (e) => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64.split(',')[1] || '';
  }

  const handleChangeStatus = () => {};
  const handleSubmitImage = async (files, allFiles) => {
    setLoading(true);
    for (let i = 0; i < files.length; i++) {
      const fileMaterial = files[i].file;
      const metaMaterial = files[i].meta;
      let base64ResultMaterial = '';
      if (metaMaterial.type.indexOf('image') !== -1) {
        const resizedImageMaterial = await compressMaterial.compress(
          [fileMaterial],
          {
            quality: 1, // the quality of the image, max is 1,
            maxWidth: 1920, // the max width of the output image, defaults to 1920px
            maxHeight: 1920, // the max height of the output image, defaults to 1920px
            resize: true // defaults to true, set false if you do not want to resize the image width and height
          }
        );
        const imgMaterial = resizedImageMaterial[0];
        base64ResultMaterial = imgMaterial.data;
      } else {
        base64ResultMaterial = await base64Reader(fileMaterial);
      }
      const data = {
        FileName: metaMaterial.name,
        FileType: metaMaterial.type,
        ReceiptNumber: receiptNumber,
        FileData: base64ResultMaterial,
        TypeId: selectedFileType?.TIP_ID,
        CreateUser: SessionUser.UserId
      };
      if (data.TypeId == undefined) {
        setresponseMessage({
          ErrorCode: 0,
          ErrorDescription: 'İşlem başarısız lütfen dosya tipini seçiniz.'
        });
        setUyari(true);
        setLoading(false);
        return;
      } else {
        uploadFiles(data);
        allFiles.forEach((f) => f.remove());
        setLoading(false);
        setUploadFilePopUp(false);
      }
    }
  };

  const setNewWindowOpen = (row) => {
    const isImage = row?.contentType?.includes('image');
    const isPdf = row?.contentType?.includes('pdf');

    // Object URL'i hedef pencerede/indirmede goster
    const render = (url, targetWindow) => {
      if (isImage && targetWindow) {
        targetWindow.document.open();
        targetWindow.document.write(
          `<img src='${url}' style='max-width:1000px;max-height:700px;'/>`
        );
        targetWindow.document.title = row.fileName;
        targetWindow.document.close();
      } else if (isPdf && targetWindow) {
        targetWindow.document.open();
        targetWindow.document.write(
          `<iframe width='100%' height='100%' src='${url}'></iframe>`
        );
        targetWindow.document.title = row.fileName;
        targetWindow.document.close();
      } else {
        // Güvenli: bilinmeyen tipleri tarayıcıda çalıştırma, indir
        const a = document.createElement('a');
        a.href = url;
        a.download = row.fileName || 'dosya';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    };

    const cached = prefetchRef.current[row.fileId];

    // Prefetch hazirsa: aninda ac (pencereyi kullanici hareketiyle senkron ac)
    if (cached && cached.url) {
      const w = isImage || isPdf ? window.open('') : null;
      render(cached.url, w);
      return;
    }

    // Henuz hazir degil: pencereyi senkron ac, dosyayi indir, sonra goster
    const w = isImage || isPdf ? window.open('') : null;
    if (w) {
      w.document.write('Yükleniyor...');
    }
    axios
      .get('/GetFileContent/' + receiptNumber + '/' + row.fileId, {
        responseType: 'blob'
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: row.contentType });
        const url = URL.createObjectURL(blob);
        prefetchRef.current[row.fileId] = { url, loading: false };
        render(url, w);
      })
      .catch((err) => {
        if (w) {
          w.document.open();
          w.document.write('Dosya yüklenemedi.');
          w.document.close();
        }
      });
  };

  function HandleChangeColorClick(Color) {
    setRenk({ ...renk, [Color]: 'purple' });
  }

  function HandleChangeColorResetClick() {
    setRenk('black');
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AlertAndLoading
        Message={responseMessage}
        open={uyari}
        AlertType={alertType}
        onClose={uyariKapat}
      />
      <Card className={classes.mainCard}>
        <CardHeader
          className={classes.cardHeader}
          avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
          action={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Tooltip title="Dosya Bilgilerini Görüntüle" placement="top">
                <Badge
                  badgeContent={openFileCount}
                  color="primary"
                  onClick={() => getReceiptFiles()}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  sx={{
                    cursor: 'pointer',
                    '& .MuiBadge-badge': {
                      backgroundColor: '#263238',
                      color: '#fff',
                      fontWeight: '700',
                      fontSize: '11px',
                      height: '20px',
                      minWidth: '20px',
                      padding: '0 5px',
                      top: '2px',
                      right: '2px',
                      cursor: 'pointer',
                      animation: 'pulse 2s ease-in-out infinite',
                      '@keyframes pulse': {
                        '0%': {
                          transform: 'scale(1)',
                          boxShadow: '0 0 0 0 rgba(38, 50, 56, 0.7)'
                        },
                        '50%': {
                          transform: 'scale(1.05)',
                          boxShadow: '0 0 0 6px rgba(38, 50, 56, 0)'
                        },
                        '100%': {
                          transform: 'scale(1)',
                          boxShadow: '0 0 0 0 rgba(38, 50, 56, 0)'
                        }
                      }
                    }
                  }}
                >
                  <IconButton
                    onClick={() => getReceiptFiles()}
                    sx={{
                      color: '#FF9800',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 152, 0, 0.08)',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.2s'
                    }}
                  >
                    <FolderIcon sx={{ fontSize: '28px' }} />
                  </IconButton>
                </Badge>
              </Tooltip>
              <Tooltip title="Dosya Ekle" placement="top">
                <IconButton
                  onClick={() => setUploadFilePopUp(true)}
                  sx={{
                    color: '#FF9800',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 152, 0, 0.08)',
                      transform: 'scale(1.1)'
                    },
                    transition: 'all 0.2s'
                  }}
                >
                  <AddPhotoAlternateIcon sx={{ fontSize: '28px' }} />
                </IconButton>
              </Tooltip>
            </Box>
          }
          ol
          title="Dosya Bilgileri"
        />
      </Card>

      <Dialog
        open={openFilePopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: '16px' }
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: '700',
            fontSize: '14px',
            color: '#424242',
            borderBottom: '1px solid #e0e0e0'
          }}
        >
          Dosya Listesi
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <List>
              {fileList.map((row, index) => (
                <ListItem key={index}>
                  <ListItemButton
                    style={{ display: 'flex', cursor: 'pointer' }}
                  >
                    <ListItemIcon>
                      <DeleteIcon
                        onClick={() => {
                          handleDeleteSureClick(
                            row.fileId,
                            row.fileCreateUserId
                          );
                        }}
                        style={{ color: '#FF9800' }}
                      />
                      <FolderIcon style={{ color: '#424242' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography type="body2" className={classes.div2}>
                          {row.fileName}
                        </Typography>
                      }
                      style={{
                        color: renk[row.fileId] || 'black'
                      }}
                      onClick={() => {
                        setNewWindowOpen(row);
                        // setShowFile(true)
                        // setSelectedFile(row)
                        HandleChangeColorClick(row.fileId);
                      }}
                    />
                    <ListItemText primary={row.ContentType} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => {
              setOpenFilePopUp(false);
              HandleChangeColorResetClick();
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen
        open={showFile}
        onClose={() => setShowFile(false)}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setShowFile(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Dosya
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={() => setShowFile(false)}
            >
              Kapat
            </Button>
          </Toolbar>
        </AppBar>
        {selectedFile?.contentType.includes('image') ? (
          <Grid container alignItems="center" justify="center">
            <Grid
              item
              sm={12}
              alignItems="center"
              justify="center"
              textAlign="center"
            >
              <img
                src={selectedFile.fileURL}
                srcSet={selectedFile.fileURL}
                alt={selectedFile.fileURL}
                loading="lazy"
                style={{
                  objectFit: 'contain',
                  padding: 5,
                  maxWidth: '100%',
                  maxHeight: 50
                }}
              />
            </Grid>
          </Grid>
        ) : (
          <iframe
            width="100%"
            height="100%"
            src={selectedFile?.fileURL}
          ></iframe>
        )}
      </Dialog>
      <Dialog
        open={uploadFilePopUp}
        onClose={() => setUploadFilePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: '16px' }
        }}
      >
        <DialogTitle
          sx={{
            width: '100%',
            color: '#424242',
            fontWeight: '700',
            fontSize: '14px',
            borderBottom: '1px solid #e0e0e0'
          }}
        >
          Dosya Yükle
        </DialogTitle>
        <DialogContent>
          <Grid item xs={12} style={{ paddingTop: 20 }}>
            <Autocomplete
              id="combo-box-demo"
              options={fileTypeData}
              getOptionLabel={(i) => i.ACIKLAMA}
              value={selectedFileType || null}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Dosya Tipi"
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: '12px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                  }}
                />
              )}
              onChange={(event, val) => {
                setSelectedFileType(val);
              }}
            />
          </Grid>
          <Grid container spacing={2} style={{ paddingTop: 20 }}>
            <Grid item xs={12} md={12}>
              <Dropzone
                onChangeStatus={handleChangeStatus}
                onSubmit={handleSubmitImage}
                styles={{
                  dropzone: { minHeight: 200, maxHeight: 250 }
                }}
                submitButtonContent="Yükle"
                minSize={0}
                maxSize={8072000}
                inputWithFilesContent={(files) => `${5 - files.length} ekle`}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={() => {
                setUploadFilePopUp(false);
                setSelectedFileType(null);
              }}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default FileInfo;
